import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResponseGetAllWatchlist, Watchlist } from '../types/add-wl.types';
import { Observable } from 'rxjs';
import { SettingsService } from './settings.service';

@Injectable()
export class WatchlistService {
  constructor(
    private httpClient: HttpClient,
    private settingsService: SettingsService
  ) {}

  getPoid() {
    return this.settingsService.getPoid();
  }

  getApiUrl() {
    return this.settingsService.getApiUrl();
  }

  getAllWatchlists(label: string): Observable<ResponseGetAllWatchlist> {
    const apiUrl = this.getApiUrl();

    return this.httpClient.get<ResponseGetAllWatchlist>(`${apiUrl}/watchlists/add-wl/${label}`, {withCredentials: true});
  }

  createNewWatchlist(watchlist: Pick<Watchlist, 'title' | 'settings'>): Observable<Watchlist> {
    const apiUrl = this.getApiUrl();
    const poid = this.getPoid();

    const payload = { poid, ...watchlist, createdBy: poid, isDeleted: false, watchlistItems: [] };
    const httpOptions = {
      withCredentials: true,
      headers: new HttpHeaders({
        'Consumer-Application-Code': 'FWF',
      }),
    };
    return this.httpClient.post<Watchlist>(`${apiUrl}/watchlists`, payload, httpOptions);
  }

  updateWatchlist(watchlist: Watchlist, wid: string) {
    const apiUrl = this.getApiUrl();

    return this.httpClient.put(`${apiUrl}/watchlists/patch/${wid}`, watchlist, { withCredentials: true });
  }
}
